import script from "./BrandList.vue?vue&type=script&setup=true&lang=js"
export * from "./BrandList.vue?vue&type=script&setup=true&lang=js"

import "./BrandList.vue?vue&type=style&index=0&id=24e4bc62&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24e4bc62"]])

export default __exports__